import classNames from 'classnames';
import React, { FC } from 'react';

export const Loading: FC<{ className?: string }> = ({ className }) => {
    return <div className={classNames('spinner m-auto', className)} role="status" aria-hidden="true" />;
};
